export const defaultFormValues = {
  email: '',
  password: '',
};

export enum ErrorsFormEnum {
  SignInError = 'Incorrect email or password',
  UserNotFound = 'User does not exist',
}
